<template>
  <validation-provider
    #default="{ errors }"
    name="alumno"
    rules="required"
  >
    <v-select
      placeholder="Búsque al alumno por su matricula y selecciónela"
      label="matricula"
      :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
      :filterable="false"
      :options="personas"
      :clearable="false"
      @search="onSearch"
      @input="(val) => $emit('matricula', val)"
    >
      <!-- CUANDO NO HAY OPCIONES -->
      <template #no-options>
        Ingrese la <b>Matricula</b> del alumno
      </template>
      <!-- COMO SE VEN LAS OPCIONES -->
      <template #option="{ matricula, nombre, segundoNombre, apellidoPaterno, apellidoMaterno }">
        <span><b>{{ matricula }}</b> - {{ nombre }} {{ segundoNombre }} {{ apellidoPaterno }} {{ apellidoMaterno }} </span>
      </template>
      <!-- COMO SE VE LA OPCIÓN SELECCIONADA -->
      <template #selected-option="{ matricula, nombre, segundoNombre, apellidoPaterno, apellidoMaterno }">
        <div>
          <b class="text-primary">{{ matricula }}</b> - {{ nombre }} {{ segundoNombre }} {{ apellidoPaterno }} {{ apellidoMaterno }}
        </div>
      </template>
    </v-select>
    <small class="text-danger">{{ errors[0] }}</small>
  </validation-provider>
</template>

<script>
import vSelect from 'vue-select'
import store from '@/store'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref } from '@vue/composition-api'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  components: { vSelect, ValidationProvider },

  setup(_, { emit }) {
    const personas = ref([])
    const toast = useToast()
    const onSearch = (search, loading) => {
      if (search.length < 1) return false // SEARCH IT'S EMPTY OR LESS THAN 4 LETTERS

      loading(true)
      getData({ token: store.state.cuenta.session.token, action: 16, data: search }, 'wsusuarios')
        .then(response => {
          loading(false)
          if (response.status === 200 && response.data.status === 200) {
            personas.value = response.data.data
            return true
          }
          personas.value = []
          emit('matricula', {})
          return false
        })
        .catch(err => {
          loading(false)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: `${err}Error en solicitud [alumno]`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 2000 })
        })
      return true
    }
    return {
      onSearch,
      personas,
      required,
    }
  },
}

</script>
